export const FORCE_SHOPPING_PREFS_MODAL_PATHNAME = '/me/shopping-preferences/';
export const WOMEN_UNIVERSE = 1;
export const MEN_UNIVERSE = 2;

export const LOCAL_KEY = 'shoppingPrefs';
export const SESSION_KEY = 'shoppingPrefsSession';
